import React, { useContext, useState } from "react";
import {
  FormControl,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { DeploymentContext } from "../../context";
import { SectionGridContainer, SectionGridLayout } from "../../components/Layout";
import { LoadingOverlay } from "../../components/Navigation/LoadingOverlay";
import { FilledTextField } from "../../components/FormElements";
import { validateEmail } from "../../services/misc.service";

const Shipping = () => {
  const { requestShipping, shippingResponse } = useContext(DeploymentContext);
  const { t } = useTranslation();
  const [emailDirty, setEmailDirty] = useState(false);
  const [email, setEmail] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const submit = async () => {
    setLoadingSubmit(true);
    try {
      if (!validateEmail(email)) throw new Error("Invalid Email");
      await requestShipping([email]);
    } catch (e) {
      console.error(e);
      setLoadingSubmit(false);
    }
    setLoadingSubmit(false);
  };

  if (loadingSubmit) {
    return <LoadingOverlay />;
  }
  return (
    <SectionGridLayout>
      <SectionGridContainer spaceContents>
        <Grid item xs={12}>
          <Typography variant="h5">{t("Shipping.Title")}</Typography>
        </Grid>
        <Grid item xs={12}>
          <FilledTextField
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            label={t("RegistrationViews.RecipientEmail")}
            error={emailDirty && !validateEmail(email)}
            onBlur={() => setEmailDirty(true)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <Button onClick={submit}>Submit</Button>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          {shippingResponse && (
            <pre>{JSON.stringify(shippingResponse, undefined, 4)}</pre>
          )}
        </Grid>
      </SectionGridContainer>
    </SectionGridLayout>
  );
};

export default Shipping;
